<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Trace Removal Operation</span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="searchform">
            <div class="row d-flex justify-content-center align-items-center flex-wrap grid-margin mt-4">
                <div class="col-md-4 padd-right-file" style="display: flex;">
                    <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
                        <mat-label>Search</mat-label>
                        <div class="search-input-container">
                            <input placeholder="Enter Application Number" id="search" matInput
                                formControlName="searchQuery" type="text" #searchInput>
                        </div>
                    </mat-form-field>
                    <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
                        (click)="searchinput()">
                        <mat-icon style="color: white;">search</mat-icon>
                    </button>
                </div>
                <div class="col-2">
                    <button type="button" class="btn reset_btn" (click)="clearFilter()">
                        <i class="fa fa-refresh"></i> reset
                    </button>


                </div>
            </div>

        </form>

        <div class="container my-4" *ngIf="isshow">
            <form [formGroup]="form">
                <div class="row">
                    <div class="col-12 ">
                        <span class="title_header_bar" *ngIf="data.traceRemovalOperationType==1">Service Change
                            Details</span>
                        <span class="title_header_bar" *ngIf="data.traceRemovalOperationType==2">Service Cancellation
                            Details</span>
                        <span class="title_header_bar" *ngIf="data.traceRemovalOperationType==3">Account Transfer
                            Details</span>
                        <span class="title_header_bar" *ngIf="data.traceRemovalOperationType==4">Address Change
                            Details</span>

                    </div>
                </div>
                <!--Service Upgrade or Downgrade-->
                <div class="card card_content" *ngIf="data.traceRemovalOperationType==1">

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Customer</mat-label>
                                <input matInput maxlength="25" formControlName="customerName"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Account Code</mat-label>
                                <input matInput maxlength="25" formControlName="customerCode"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Application</mat-label>
                                <input matInput maxlength="25" formControlName="applicationReferenceNumber"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Service Provider</mat-label>
                                <input matInput maxlength="25" formControlName="serviceProvider"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Service Change Reference</mat-label>
                                <input matInput maxlength="25" formControlName="serviceReferenceNumber"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Current Product</mat-label>
                                <input matInput maxlength="25" formControlName="currentProductName"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>New Product</mat-label>
                                <input matInput maxlength="25" formControlName="upgradeOrDowngradeProductName"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Status</mat-label>
                                <input matInput maxlength="25" formControlName="changeRequestStatusTypeName"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Requested Date</mat-label>
                                <input matInput maxlength="25" formControlName="requestedDate"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Approved Date</mat-label>
                                <input matInput maxlength="25" formControlName="approveCancellationDate"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                </div>



                <!-- service cancellation -->
                <div class="card card_content" *ngIf="data.traceRemovalOperationType==2">

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Customer</mat-label>
                                <input matInput maxlength="25" formControlName="customerName"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Account Code</mat-label>
                                <input matInput maxlength="25" formControlName="customerCode"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Application</mat-label>
                                <input matInput maxlength="25" formControlName="applicationReferenceNumber"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Service Provider</mat-label>
                                <input matInput maxlength="25" formControlName="serviceProvider"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Cancellation Reference</mat-label>
                                <input matInput maxlength="25" formControlName="serviceReferenceNumber"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Status</mat-label>
                                <input matInput maxlength="25" formControlName="changeRequestStatusTypeName"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Requested Date</mat-label>
                                <input matInput maxlength="25" formControlName="requestedDate"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Approved Date</mat-label>
                                <input matInput maxlength="25" formControlName="approveCancellationDate"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <!--Transfer Account-->

                <div class="card card_content" *ngIf="data.traceRemovalOperationType==3">

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Existing Customer</mat-label>
                                <input matInput maxlength="25" formControlName="customerName"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>New Customer</mat-label>
                                <input matInput maxlength="25" formControlName="receiverCustomerName"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Application</mat-label>
                                <input matInput maxlength="25" formControlName="applicationReferenceNumber"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Service Provider</mat-label>
                                <input matInput maxlength="25" formControlName="serviceProvider"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Status</mat-label>
                                <input matInput maxlength="25" formControlName="transferStatusName"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Requested Date</mat-label>
                                <input matInput maxlength="25" formControlName="requestedDate"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Approved Date</mat-label>
                                <input matInput maxlength="25" formControlName="approveCancellationDate"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                </div>


                <!--Address Change-->

                <div class="card card_content" *ngIf="data.traceRemovalOperationType==4">

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Customer</mat-label>
                                <input matInput maxlength="25" formControlName="customerName"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Account Code</mat-label>
                                <input matInput maxlength="25" formControlName="customerCode"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Old Application</mat-label>
                                <input matInput maxlength="25" formControlName="applicationReferenceNumber"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>New Application</mat-label>
                                <input matInput maxlength="25" formControlName="newApplicationReferenceNumber"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Old Service Provider</mat-label>
                                <input matInput maxlength="25" formControlName="serviceProvider"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>New Service Provider</mat-label>
                                <input matInput maxlength="25" formControlName="newServiceProvider"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mx-4">
                        <div class="col-sm-12 col-xl-6 mt-4">

                            <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'textArea-mat-field'"
                                style="border-radius: 0 !important;">
                                <mat-label>Old Address</mat-label>
                                <textarea rows="4" matInput type="text" placeholder="Enter Query"
                                    formControlName="oldAddress" autocomplete="off" specialIsAlphaNumeric
                                    class="col-12"></textarea>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-xl-6 mt-4">

                            <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'textArea-mat-field'"
                                style="border-radius: 0 !important;">
                                <mat-label>New Address</mat-label>
                                <textarea rows="4" matInput type="text" placeholder="Enter Query"
                                    formControlName="newAddress" autocomplete="off" specialIsAlphaNumeric
                                    class="col-12"></textarea>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mx-4">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Status</mat-label>
                                <input matInput maxlength="25" formControlName="addressChangeStatusName"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Requested Date</mat-label>
                                <input matInput maxlength="25" formControlName="requestedDate"
                                    placeholder="Enter Product Cost" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                </div>

                <div class="d-flex justify-content-end button-style mt-3">
                    <button class="btn btn-primary my-3 mr-3" type="submit" (click)="clearFilter()"
                        matButton>Cancel</button>
                    <button class="btn btn-secondary my-3 " type="submit" (click)="save()" matButton>Remove
                        Trace</button>

                </div>
            </form>
        </div>
    </div>
</div>